import axios from "axios";

export async function setApprove(assessment: string, subcategory: string, approve: boolean) {
    let response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/assessment/approve/"+assessment, {
        subcategory: subcategory,
        approve: approve ? 1 : 0, 
    });
    return response.data;
}